import React from 'react';
import './BulletedMatchedRuleDescription.styl';
import chunk from 'lodash/chunk';
import {stripHtmlNewlinesExtraSpaces} from 'utils/stripHtml';

/**
 * Decodes html elements.
 * Sadly making an html element and then reading the values from the element is the internet's favored way...
 * ... and the only suggestion that seemed to consistently work.
 * @returns {string|string}
 */
export function htmlDecode(input) {
  const e = document.createElement('textarea');
  e.innerHTML = input;
  // handle case of empty input
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
}

/**
 * Need to stripe out html tags, convert encoded html back to @ etc.
 * Also shortens to a maximum length starting at the first @mention if too long.
 * @returns {string}
 */
function prepareText(text) {
  const maxLineLength = 200;
  const decodedText = htmlDecode(stripHtmlNewlinesExtraSpaces(text)).toString();
  const atMentionIndex = decodedText.indexOf('@'); // -1 means no @ mention
  let preparedText = decodedText;
  // want to shorten @ mentions if they exceed the provided length
  if (preparedText.length > maxLineLength && atMentionIndex !== -1) {
    preparedText = decodedText.slice(0, maxLineLength) + '...';
  }
  return preparedText;
}

/**
 * Component to render the reason why a rule was triggered.
 *
 * Similar, yet different, from BulletedRuleDescription.  If you make changes here,
 * check that component too.
 */
export default class BulletedMatchedRuleDescription extends React.PureComponent {
  render() {
    const parts = prepareText(this.props.text).split(/(\bAND\b|;)/g);
    const actionNames = this.props.actionNames || [];
    const numActions = actionNames.length;
    const timing = this.props.timing && this.props.timing.split('AND');
    const pairs = chunk(parts.slice(1), 2);

    return (
      <div className="bulleted-matched-rule-wrapper">
        <div className="event-description">
          <div>
            {parts[0].trim()}
            {timing && parts.length > 1 && ' that'}
          </div>
          {pairs.length >= 1 && (
            <ul>
              {pairs.map((part, i) => (
                <li key={i} className={part[0] === 'AND' ? 'and-item' : 'or-item'}>
                  <div>
                    {part[0] === 'AND' && i !== 0 ? 'and ' : ''}
                    {part[1].trim()}
                  </div>
                </li>
              ))}
            </ul>
          )}
          {!timing && numActions > 0 && (
            <ul>
              {actionNames.map((part, i) => (
                <li key={i}>{part.trim()}</li>
              ))}
            </ul>
          )}
        </div>
        {timing && (
          <div className="timing-description">
            {timing[0].trim()}
            {timing.length > 1 && (
              <ul>
                {timing.slice(1).map((part, i) => (
                  <li key={i}>
                    {i === 0 ? '' : 'and '}
                    {part.trim()}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    );
  }
}
